import { render, staticRenderFns } from "./AutoSearch.vue?vue&type=template&id=48b2b900&"
import script from "./AutoSearch.vue?vue&type=script&lang=js&"
export * from "./AutoSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports